
export class Options {
    constructor(
      public username: string,
      public title: string,
      public url: string) { }
  }